import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URLHelper } from 'helpers/url.helper';
import { DataService } from '../data-service';

@Injectable()
export class DashboardDataService extends DataService {

  requestStaticUsages(): Promise<any> {
    let options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    return this.get("", {"parking-lots": "PARKING_LOT_ID"}, '/usages/summary');
  }

  requestStaticTemporaryRevenues(): Promise<any> {
    let options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    return this.get("", {"parking-lots": "PARKING_LOT_ID"}, '/usages/temporary-parking/revenues/summary');
  }

  requestStaticTotalRevenues(): Promise<any> {
    let options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    return this.get("payments/", {"parking-lots": "PARKING_LOT_ID"}, '/total-revenues/summary');
  }

  requestStaticUsagesInterval(range: any): Promise<any> {
    return this.get("", {"parking-lots": "PARKING_LOT_ID"}, URLHelper.buildQueryString('/usages/intervals?', range, ''));
  }

  requestStaticUsagesAndRevenues(range: any): Promise<any> {
    return this.get("", {"parking-lots": "PARKING_LOT_ID"}, URLHelper.buildQueryString('/usages/income/week-average?', range, ''));
  }

  requestStaticUsagesRatios(range: any): Promise<any> {
    return this.get("", {"parking-lots": "PARKING_LOT_ID"}, URLHelper.buildQueryString('/usages/ratios/days-of-week?', range, ''));
  }

  requestStaticParkingLotsSpace(range: any): Promise<any> {
    return this.get("", {"parking-lots": "PARKING_LOT_ID"}, URLHelper.buildQueryString('/available-spaces/average?availableParkingLotSpaceType=NORMAL', range, ''));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data-services/dashboard/dashboard.service.ts